import { PageType } from '@shared/enums';

export const pageTypeBreadcrumbDisabled: (keyof typeof PageType)[] = ['Homepage', 'Homepage_pro', 'webserie'];
